import { Plugin } from '@ckeditor/ckeditor5-core';
import  plainTextToHtml from '@ckeditor/ckeditor5-clipboard/src/utils/plaintexttohtml';

export class AlwaysPasteAsPlainText extends Plugin {
    static get pluginName() {
        return 'AlwaysPasteAsPlainText'
    }

    init() {
        const editor = this.editor;

        const editingView = editor.editing.view;

        editingView.document.on( 'clipboardInput', ( evt, data ) => {
            if ( editor.isReadOnly ) {
                return;
            }

            const dataTransfer = data.dataTransfer;
            // Convert to plain text and replace newlines with double newlines to allow text styles to be applied per line correctly.
            let content = plainTextToHtml( dataTransfer.getData( 'text/plain' ).replace(/[\n]+/g, '\n\n' ));

            data.content = this.editor.data.htmlProcessor.toView( content );
        } );
    }
}